<template>
    <div class="container-fluid py-3">
        <div class="row w-100 d-flex justify-content-between mb-4">
            <div class="col-md-6 d-flex p-0 m-0">
                <router-link class="back-route" @click="backHandler" :to="this.isDataFlag ? '#':'/settings/roles'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                </router-link>
                &nbsp;
                <h3>Create Role</h3>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-center p-0 m-0">
                <div class="buttonSave">
                    <button :class="{notAllowed: isRoleCreatedSuccessfully}" @click.prevent="SaveRole">Save</button>
                </div>
            </div>
        </div>

        <div class="dataFill">
            <div class="row w-100">
                <div class="col-md-6 w-100 cssInput">
                    <label>Role Name <span style="color: red;">*</span></label>
                    <input type="text" v-model="role.name" class="form-control" id="name" @input="checkNumberInInputs">
                    <span class="text-danger" v-if="isErrorNumberExist">{{errorMsg}}</span>
                    <div v-if="errors['name'].length > 0">
                        <div v-for="msg in errors['name']" class="err text-danger position-absolute">{{msg}}
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div class="row">
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Add</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv">
                                <input class="form-check-input" type="checkbox" @change="checkAllCreate($event , 'add')">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" >
                                    Select All
                                </label>
                            </div>
                            <div class="d-flex cssInputDiv" v-for="permission in addPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionAdd($event , permission.name)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)" >
                                    {{permission.name.charAt(0).toUpperCase() + permission.name.slice(1) === 'Create userscore' ? 'Create User Score' : permission.name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Edit</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv">
                                <input class="form-check-input" type="checkbox" @change="checkAllEdit($event , 'edit')">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" >
                                    Select All
                                </label>
                            </div>
                            <div class="d-flex cssInputDiv" v-for="permission in editPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionEdit($event , permission.name)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{permission.name.charAt(0).toUpperCase() + permission.name.slice(1) === 'Update userscore' ? 'Update User Score' : permission.name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>View</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv">
                                <input class="form-check-input" type="checkbox" @change="checkAllView($event , 'view')">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" >
                                    Select All
                                </label>
                            </div>
                            <div class="d-flex cssInputDiv" v-for="permission in viewPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" >
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{permission.name.charAt(0).toUpperCase() + permission.name.slice(1) === 'View userscore' ? 'View User Score' : permission.name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Delete</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv">
                                <input class="form-check-input" type="checkbox" @change="checkAllDelete($event , 'delete')">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" >
                                    Select All
                                </label>
                            </div>
                            <div class="d-flex cssInputDiv" v-for="permission in deletePermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionDelete($event ,permission.name)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{permission.name.charAt(0).toUpperCase() + permission.name.slice(1) === 'Delete userscore' ? 'Delete User Score' : permission.name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import roles from '../../../api-services/roles';
    import AlartModal from "../../components/AlartModal";
    import changeHandler from "../../../validation/organizationValidation";
    import ConfirmationModal from '../../components/ConfirmationModal';
    import {computed} from "vue";

    export default {
        name:'role-createAdmin',
        data(){
            return{
                isErrorNumberExist:false,
                isRoleCreatedSuccessfully:false,
                errorMsg:'',
                changeHandler,
                permissions:[],
                addPermissions:[],
                editPermissions:[],
                deletePermissions:[],
                viewPermissions:[],
                type:'organization',
                state: false,
                ImagePath:'',
                showModal:false,
                message:null,
                role:{
                    name:null,
                    permissionsInputs:[],
                },
                errors:{
                    name:[],
                    isError: false
                },
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        async mounted(){
            this.getPermissions();
        },
        components:{
            AlartModal,
            ConfirmationModal
        },
        methods:{
            checkNumberInInputs(e) {
                this.errors.name = [];
                const regex = /\d/;
                if(e.target.value === ''){
                    this.isErrorNumberExist = true;
                    this.errorMsg = '*Required';
                }
                else if(!isNaN(e.target.value) || regex.test(e.target.value)){
                    this.isErrorNumberExist = true;
                    this.isRoleCreatedSuccessfully = true;
                    this.errorMsg = '*Role name must be letters only';
                }else{
                    this.isErrorNumberExist = false;
                    this.isRoleCreatedSuccessfully = false;
                    this.errorMsg = '';
                }
            },
            checkAllCreate(e , value){
                if(e.target.checked === true){
                    this.addPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                    this.viewPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                }else{
                    this.addPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                    this.viewPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                }
            },
            checkAllEdit(e , value){
                if(e.target.checked === true){
                    this.editPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                    this.viewPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                }else{
                    this.editPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                    this.viewPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                }
            },
            checkAllDelete(e , value){
                if(e.target.checked === true){
                    this.deletePermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                    this.viewPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                }else{
                    this.deletePermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                    this.viewPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                }
            },
            checkAllView(e , value){
                if(e.target.checked === true){
                    this.viewPermissions.forEach(item =>{
                        this.role.permissionsInputs.push(item.id);
                    });
                }else{
                    this.viewPermissions.forEach(item =>{
                        let idx = this.role.permissionsInputs.indexOf(item.id);
                        this.role.permissionsInputs.splice(idx , 1);
                    });
                }
            },
            checkPermissionAdd(e , value){
                if(e.target.checked === true){
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'view Any '+data[1]){
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    console.log(data);
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'view Any '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            checkPermissionEdit(e , value){
                if(e.target.checked === true) {
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if (item.name === 'view Any ' + data[1]) {
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'view Any '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            checkPermissionDelete(e , value){
                if(e.target.checked === true) {
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if (item.name === 'view Any ' + data[1]) {
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'view Any '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'name') {
                    if (val !== null) {
                        this.isData.name = true;
                    } else {
                        this.isData.name = false;
                    }
                }

                if (this.isData.name) {
                    this.$store.dispatch('setDataFlag', true);

                } else {
                    this.$store.dispatch('setDataFlag', false);

                }
            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/settings/roles');
                }
            },
            async getPermissions(){
                try{
                    const response = await roles.getPermissions(this.type);

                    this.permissions = response.data.data;
                    this.addPermissions = response.data.data;
                    this.editPermissions = response.data.data;
                    this.deletePermissions = response.data.data;
                    this.viewPermissions = response.data.data;

                    let filteredData1 = this.permissions.filter(function (data) {
                        return data.category === 'add' && data.name !== 'create setting' && data.name !== 'create score';
                    });
                    this.addPermissions = filteredData1;

                    let filteredData2 = this.permissions.filter(function (data) {
                        return data.category === 'edit' && data.name !== 'update setting' && data.name !== 'update score' && data.name !== 'update userscore';
                    });

                    filteredData2.map((item) => {
                        let elm = item.name.split(' ')[0];
                        console.log(elm);
                        if (elm === 'update')
                            item.name = item.name.replace('update', 'Edit')
                    });

                    this.editPermissions = filteredData2;

                    let filteredData3 = this.permissions.filter(function (data) {
                        return data.category === 'delete' && data.name !== 'delete setting' && data.name !== 'delete score' && data.name !== 'delete userscore';
                    });
                    this.deletePermissions = filteredData3;

                    let filteredData4 = this.permissions.filter(function (data) {
                        return data.category === 'view' && data.name !== 'viewAny setting' && data.name !== 'read setting' && data.name !== 'viewAny score' && data.name !== 'read score';
                    });

                    filteredData4.map((item) => {
                        let elm = item.name.split(' ')[0];
                        if (elm === 'viewAny')
                            item.name = item.name.replace('viewAny', 'view')
                    });
                    this.viewPermissions = filteredData4;


                }catch(e){
                    // console.log(e);
                }
            },
            async SaveRole(){
                try{
                    if(this.isRoleCreatedSuccessfully){
                        console.log('error');
                    }else if(this.role.name == null || this.role.name === '' || this.role.permissionsInputs.length < 1){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'Please fill data correctly';

                        if (this.role.name === null || this.role.name === '') {
                            this.errors.isError = true;
                            this.errors['name'][0] = '*Required';
                            this.isErrorNumberExist = false;
                        }
                    }else if(this.role.name === 'user' || this.role.name === 'admin' || this.role.name === 'super_admin'){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'You Can,t Enter Unique Name';
                    }else{
                        if (!this.errors.isError) {
                            let uniqueChars = this.role.permissionsInputs.filter((c, index) => {
                                return this.role.permissionsInputs.indexOf(c) === index;
                            });

                            console.log(uniqueChars);
                            const response = await roles.create({
                                name: this.role.name,
                                permissions: uniqueChars
                            });

                            if (response.status === 201) {
                                this.showModal = true;
                                this.ImagePath = 'okImage.svg';
                                this.$store.dispatch('setDataFlag', false);
                                this.message = "Role Created Successfully";
                                setTimeout(() => {
                                    this.$router.push('/settings/roles');
                                }, 2000);
                            } else {
                                // console.log('Something Wrong !');
                            }
                        }
                    }

                }catch (e) {
                    if(e.response.data.errors){
                        if(e.response.data.errors.name){
                            if(e.response.data.errors.name)
                                e.response.data.errors.name.forEach((err,idx) => { this.errors['name'][idx] = `* ${err}`});
                        }else{
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                            }
                        }
                    }else if(e.response.data){
                        this.showErrorModal = true;
                        this.ImagePath = 'close.png';
                        this.responseErrorMessage = e.response.data.message
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .notAllowed{
        cursor:not-allowed;
    }
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #E95626;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #021A24;
    }
    .cssInputDiv p{
        position: relative;
        top: 2px;
    }
    .cssInputDiv{
        border-bottom: 1px solid var(--border-color-data-table);
        padding: 10px;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }
    .cssCardBody{
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        height: 423px;
        overflow-y: auto;
        padding: 0;
    }
    .cssCardHeader{
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        border-bottom:1px solid var(--border-color-data-role) !important;
    }
    .cssCardAll{
        background-color: var(--border-color-data-table) !important;
    }
    .cssInput input{
        width:400px;
        background-color: transparent;
        border-color: #39525C;
        color: var(--main-color);
    }
    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 22px;
    }

    .back-route:hover {
        color: #FFF;
    }
    #organization_url {
        color: #fff !important;
        background-color: #032431 !important;
    }
    .fourthOrga input{
        background-color: #032431;
        color: #fff;
    }
    .secOrga input{
        background-color: #032431;
        color: #fff;
    }
    .firstOrga input{
        background-color: #032431;
        color:#fff;
    }
    .designBasic{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .designBasic .createDiv{
        display: flex;
        flex-direction: row;
    }
    .designBasic .createDiv button{
        border:none;
        color:#fff;
        background-color: transparent;
    }
    .buttonSave button{
        border:none;
        color:#fff;
        background-color: var(--btn-bg-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .dataFill{
        border: 1px solid var(--border-color-data-table);
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        padding: 23px;
        border-radius: 15px;
        height: calc(100vh - 18vh);
        margin-right: 12px;
        margin-left: -12px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .cssCardBody{
            height: 300px;
            overflow: scroll;
        }
    }
</style>